/**
 * Checks if the authentication token has expired
 * @returns {boolean} true if token is expired, false otherwise
 */
export const isTokenExpired = () => {
  const expiresAt = localStorage.getItem('tokenExpiresAt');

  if (!expiresAt) {
    return false; // No expiry info, assume valid (backwards compatibility)
  }

  try {
    const expiryTimestamp = parseInt(expiresAt, 10);
    const currentTimestamp = Math.floor(Date.now() / 1000);

    return currentTimestamp >= expiryTimestamp;
  } catch (error) {
    console.error('Error checking token expiry:', error);
    return false;
  }
};

/**
 * Gets the token expiry timestamp
 * @returns {number|null} Unix timestamp or null if not found
 */
export const getTokenExpiry = () => {
  const expiresAt = localStorage.getItem('tokenExpiresAt');
  return expiresAt ? parseInt(expiresAt, 10) : null;
};

/**
 * Gets time remaining until token expires
 * @returns {number} Seconds until expiry, negative if already expired
 */
export const getTimeUntilExpiry = () => {
  const expiryTimestamp = getTokenExpiry();
  if (!expiryTimestamp) return Infinity;

  const currentTimestamp = Math.floor(Date.now() / 1000);
  return expiryTimestamp - currentTimestamp;
};
